import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { DRxTheme } from "./Theme";
import { ThemeProvider } from "@mui/material/styles";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import StoreConfig from "./Redux/StoreConfig";
import CssBaseline from "@mui/material/CssBaseline";
import ErrorPage from "./components/ErrorPage";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <ThemeProvider theme={DRxTheme}>
    <CssBaseline>
      <Provider store={StoreConfig}>
        <HashRouter>
          <ErrorBoundary fallback={<ErrorPage />}>
            <App />
          </ErrorBoundary>
        </HashRouter>
      </Provider>
    </CssBaseline>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
